import React, { useEffect, useRef } from "react";
import { connect } from 'react-redux';
import { LabelPadrao } from "../../components/Base";
import { InputNumero } from "../../components/InputNumero";
import SelectFiltros from "../../components/Selects/SelectFiltros";
import ModalCartao from "./ModalCartao";
import ModalCrediario from "./ModalCrediario";
import Mensagens from "../../components/Mensagens";
import { BtnDeletar, BtnEdit } from "../../components/Buttons";
import ModalVale from "./ModalVale";

function ModalidadePgDet({ pg, setPg, liquido, noLabel, onOk, onDelete, first, semValorMaximo, index, tabIndex, disabled, hideOperacoes, clienteId, tipo, isEntrega, ...props }) {
  const selectRef = useRef();
  const inputRef = useRef();

  function selectModalidade(id) {

    let modalidade = props[`modalidades${tipo || ""}`].find(x => x.id == id);

    if ((modalidade.tipo == "crediario" || modalidade.tipo == "vale") && !clienteId && !hideOperacoes)
      return Mensagens.showWarning("Informe um cliente para utilizar esta modalidade.");

    var recebido = 0;
    if (!semValorMaximo)
      recebido = modalidade.tipo == "troco" ? pg.recebido : pg.recebido > liquido ? liquido : pg.recebido;

    const aux = { ...modalidade, modalidadeId: modalidade.id, recebido };

    if (tipo != "venda" && tipo != "sinal")
      aux.cartaoEmpresaTipos = [];

    setPg(aux);
  }

  const tabIndexInternal = tabIndex + (index * 2);

  const cancelarOperacao = () => { setPg({ modalidadeId: null, recebido: pg.recebido }); selectRef.current?.focus(); };

  const operacaoHidden = !!hideOperacoes?.length ? hideOperacoes.includes(pg.tipo) : !!hideOperacoes;

  useEffect(() => selectRef.current?.focus(), []);

  return <>
    <div style={{ width: "100%", display: "flex", marginBottom: 10, alignItems: "center" }}>
      <div style={{ width: "50%", marginRight: 10 }}>
        {!noLabel && <LabelPadrao noMargin>Modalidade pagamento</LabelPadrao>}
        <SelectFiltros
          tipo={tipo}
          showSearch
          ref={selectRef}
          placeholder="Informe a modalidade"
          modelo="modalidadePgto"
          value={pg.modalidadeId}
          onChange={selectModalidade}
          tabIndex={tabIndexInternal}
          dataCy={"select-mod-" + index}
          disabled={disabled || pg.isSinal}
        />

      </div>
      <div style={{ width: "50%" }}>
        {!noLabel && <LabelPadrao noMargin>Valor recebido</LabelPadrao>}
        <InputNumero
          ref={inputRef}
          value={pg.recebido}
          onChange={v => setPg({ ...pg, recebido: v })}
          onBlur={!!pg.recebido && onOk}
          onPressEnter={v => pg.recebido && onOk(v.target.value)}
          dataCy={`input-mod-${index}`}
          min={liquido > 0 ? 0 : liquido}
          max={(pg.tipo == "troco" || semValorMaximo) ? Number.MAX_SAFE_INTEGER : liquido}
          tabIndex={tabIndexInternal + 1}
          disabled={disabled || pg.isSinal}
          style={{ width: "100%" }}
        />
      </div>

      <div style={{ display: "flex", alignItems: "flex-end", marginTop: !noLabel ? 15 : 0 }}>
        <BtnEdit style={{ visibility: ((pg.tipo == "cartao" || pg.tipo == "crediario" || pg.tipo == "vale") && !pg.isSinal && !operacaoHidden) ? "visible" : "hidden", margin: "0 5px" }} small onClick={() => {
          if (pg.tipo == "cartao")
            setPg({ ...pg, cartao: null, cartaoEdicao: pg.cartao });
          else if (pg.tipo == "crediario")
            setPg({ ...pg, crediarios: [], crediarioEdicao: pg.crediario });
          else if (pg.tipo == "vale")
            setPg({ ...pg, vales: [], valesEdicao: pg.vales });
        }} />
        <BtnDeletar style={{ visibility: (index > 0 && !pg.isSinal) ? "visible" : "hidden" }} small disableModal onOk={onDelete} />
      </div>
    </div>

    <ModalCrediario
      visible={!operacaoHidden && pg?.tipo == "crediario" && !pg?.crediarios?.length}
      edicao={pg.crediarioEdicao}
      nome={pg.nome}
      idPlanoContaPadrao={pg.planoContaId}
      recebido={pg.recebido}
      onCancel={cancelarOperacao}
      onOk={crediario => setPg({ ...pg, crediarios: crediario.crediarios, recebido: crediario.valor, idPlanoConta: crediario.idPlanoConta, crediario, crediarioEdicao: null })}
      hasCliente={!!clienteId}
    />

    <ModalVale
      visible={!operacaoHidden && pg?.tipo == "vale" && !pg?.vales?.length}
      edicao={pg.valesEdicao}
      nome={pg.nome}
      onCancel={cancelarOperacao}
      onOk={(vales, recebido) => {
        const valorMenor = pg.recebido > recebido;
        setPg({ ...pg, vales, recebido: valorMenor ? recebido : pg.recebido, valesEdicao: null });

        if (valorMenor)
          inputRef.current.focus();
      }}
      clienteId={clienteId}
    />

    <ModalCartao
      visible={!operacaoHidden && !pg.isSinal && pg?.tipo == "cartao" && !pg?.cartao && (pg.hasBandeira || pg.cartaoEmpresaTipos?.length)}
      edicao={pg.cartaoEdicao}
      cartaoEmpresaTipos={pg.cartaoEmpresaTipos}
      pg={pg}
      onCancel={cancelarOperacao}
      onOk={cartao => setPg({ ...pg, ...cartao, cartao, cartaoEdicao: null })}
      isEntrega={isEntrega}
    />
  </>;
}

const mapStateToProps = state => ({ modalidades: state.pesq.modalidadepgto, modalidadesvenda: state.pesq.modalidadepgtovenda, modalidadesfechamento: state.pesq.modalidadepgtofechamento, modalidadesfinanceiro: state.pesq.modalidadepgtofinanceiro, modalidadessinal: state.pesq.modalidadepgtosinal, modalidadesdevolucao: state.pesq.modalidadepgtodevolucao });

export default connect(mapStateToProps, {})(ModalidadePgDet);